import Chart from "react-apexcharts";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import dayjs from 'dayjs';
import '../../../../cssfiles/homepage.css';

export default function MixedChart2LinesBarMarkerComponent(props) {
    const tagcollectionvalue = useSelector((state) => state.mainpagedata.tagcollectionvalues);
    const dateformatselected = useSelector((state) => state.mainpagedata.selecteddate);
    console.log("inside mixed chart**********************tagcollectionvalue********************", tagcollectionvalue);
    const sdate_edate_selected = useSelector((state) => state.mainpagedata.selecteddates)

    const [seriesChart, setSeriesChart] = useState([]);
    const [options, setOptions] = useState({});

    console.log("in Mixedchart-sdate_edate_selected.startdates",sdate_edate_selected.startdates)
    console.log("in Mixedchart-sdate_edate_selected.enddates",sdate_edate_selected.enddates)
     
    const getXAxisFormat = (dateformatselected) => {
        switch (dateformatselected) {
            case 'This Year':
                return (value) => dayjs(value).format('MMMM'); // Jan, Feb, Mar, Apr...
            case 'Last Year':
                return (value) => dayjs(value).format('MMMM'); // Jan, Feb, Mar, Apr...
            case 'This Month':
                return (value) => dayjs(value).format('D'); // 1, 2, 3, ..., 30
            case 'Last Month':
                return (value) => dayjs(value).format('D'); // 1, 2, 3, ..., 30
            case 'This Week':
                return (value) => dayjs(value).format('ddd'); // Sun, Mon, Tue...
            case 'Last Week':
                return (value) => dayjs(value).format('ddd'); // Sun, Mon, Tue...
            case 'Today':
                return (value) => dayjs(value).format('HH'); // 00, 01, 02, ..., 23
            case 'Yesterday':
                return (value) => dayjs(value).format('HH'); // 00, 01, 02, ..., 23
            case 'Last 24 hours':
                return (value) => dayjs(value).format('HH:mm:ss'); // 00:00:00, 01:00:00, ..., 23:59:59
            default:
                return (value) => dayjs(value).format('HH:mm:ss'); // 00:00:00, 01:00:00, ..., 23:59:59
        }
    };

    useEffect(() => {
        const tagProperties = props.widgetprop.props.extended.tagprops;
        const colorPropertiesGeneral = [];
        const colorPropertiesLines = [];
        const widthPropertiesLines = [];
        const curvePropertiesLines = [];
        const legendNamePropertiesLines = [];

        const colorPropertiesBars = [];
        const widthPropertiesBars = [];
        const curvePropertiesBars = [];
        const legendNamePropertiesBars = [];

        const colorPropertiesMarkers = [];
        const widthPropertiesMarkers = [];
        const curvePropertiesMarkers = [];
        const legendNamePropertiesMarkers = [];

        let isBarHorizontal = false;

        tagProperties.forEach(chartType => {
            colorPropertiesGeneral.push(chartType.chartprops.color);
            if (chartType.charttype === 'line') {
                colorPropertiesLines.push(chartType.chartprops.color);
                widthPropertiesLines.push(2);
                curvePropertiesLines.push('smooth');
                legendNamePropertiesLines.push(chartType.legendname);
            } else if (chartType.charttype === 'bar') {
                colorPropertiesBars.push(chartType.chartprops.color);
                widthPropertiesBars.push(2);
                curvePropertiesBars.push('smooth');
                legendNamePropertiesBars.push(chartType.legendname);
                isBarHorizontal = chartType.chartprops.horizontal;
            } else if (chartType.charttype === 'marker') {
                colorPropertiesMarkers.push(chartType.chartprops.color);
                widthPropertiesMarkers.push(2);
                curvePropertiesMarkers.push('smooth');
                legendNamePropertiesMarkers.push(chartType.legendname);
            }
        });

        const seriesConsumed = tagProperties.map(chartType => {
            if (tagcollectionvalue.hasOwnProperty(chartType.tagid)) {
                console.log("tagcollectionvalue[chartType.tagid] in COMPONENT MIXEDC HART",tagcollectionvalue[chartType.tagid])
                if(chartType.charttype !== "maxlimit" && chartType.charttype !== "minlimit"){
                    return {
                        name: chartType.legendname,
                        type: chartType.charttype,
                        data: (tagcollectionvalue[chartType.tagid] !== null && tagcollectionvalue[chartType.tagid] !== undefined)?tagcollectionvalue[chartType.tagid].map((currentobj)=>{
                             var currenttimestamp = currentobj.x;
                             // const currentformatteddate = new Date(currenttimestamp);
                             var currxvalue;
                             //console.log("here dateformatselected==============",currentformatteddate.toLocaleDateString('en-us', { month:"short"}))
                            /*  switch (dateformatselected) {
                                case 'This Year':
                                    currxvalue = currentformatteddate.toLocaleDateString('en-us', { month:"short"});
                                    break;
                                case 'Last Year':
                                    currxvalue = currentformatteddate.toLocaleDateString('en-us', { month:"short"});
                                    break;
                                case 'This Month':
                                    currxvalue = currentformatteddate.toLocaleDateString('en-us', { day:"numeric"});
                                    break;
                                case 'Last Month':
                                    currxvalue = currentformatteddate.toLocaleDateString('en-us', { day:"numeric"});
                                    break;
                                case 'This Week':
                                    currxvalue = currentformatteddate.toLocaleDateString('en-us', { weekday:"long"});
                                    break;
                                case 'Last Week':
                                    currxvalue = currentformatteddate.toLocaleDateString('en-us', { weekday:"long"});
                                    break;
                                case 'Today':
                                    currxvalue = currentformatteddate.toLocaleDateString('en-us', { hour:"numeric"});
                                    break;
                                case 'Yesterday':
                                    currxvalue = currentformatteddate.toLocaleDateString('en-us', { hour:"numeric"});
                                    break;
                                case 'Last 24 hours':
                                    currxvalue = currentformatteddate.toLocaleDateString('en-us', { hour:"numeric"})
                                    break;
                                case 'Custom':
                                    // currxvalue = currentformatteddate.toLocaleDateString('en-us', { day:"numeric"})
                                    if(tagcollectionvalue[chartType.tagid].length > 30 ){
                                        var currentdaydate = currentformatteddate.getDate();
                                        if((currentdaydate == '1') || currentdaydate == 1){
                                            currxvalue = currentformatteddate.toLocaleDateString('en-us', {day:"numeric", month:"short"})
                                        }else{
                                            currxvalue = '.'
                                        }
                                    }else if(tagcollectionvalue[chartType.tagid].length <= 30 ){
                                        currxvalue = currentformatteddate.toLocaleDateString('en-us', { day:"numeric"})
                                    }

                                    break;
                                
                            }
                            */
                                    
                            console.log("mixed here currxvalue",tagcollectionvalue[chartType.tagid].length)
                            return({
                                x:currentobj.x,
                                y:currentobj.y
                            })
                                
                        }):null
                    };
                }
            }
            return null;
        }).filter(item => item !== null);

        const yaxisProperties = tagProperties.map(chartType => {
            if(chartType.charttype !== "maxlimit" && chartType.charttype !== "minlimit"){
                return {
                    show: chartType.yaxis_show ?? true,
                    seriesName: chartType.seriesnameassociated ?? "",
                    forceNiceScale: true,
                    labels: {
                        show: true,
                        style: {
                            colors: 'var(--axis-color)',
                            fontSize: props.widgetprop.props.extended.fontsize,
                            fontFamily: props.widgetprop.props.extended.fontfamily,
                            fontWeight: props.widgetprop.props.extended.fontweight,
                        },
                        formatter: (value) => { 
                            if((value !== undefined) && (value!==null)){
                                return value.toFixed(2)
                            } 
                        },
                    },
                    title: {
                        text: chartType.yaxis_title.titlename ?? "",
                        style: {
                            color: 'var(--axis-title-color)',
                            fontSize: props.widgetprop.props.extended.title.fontsize,
                            fontFamily: props.widgetprop.props.extended.title.fontfamily,
                            fontWeight: props.widgetprop.props.extended.title.fontweight,
                        },
                    },
                }
            }
            return null;
        
        }).filter(item => item !== null);

       // const firstTag = Object.keys(tagcollectionvalue)[0];
       // const categories = tagcollectionvalue[firstTag] ? tagcollectionvalue[firstTag].map(item => item.x) : [];

        const optionsConsumption = {
            chart: {
                type: "line",
                zoom: {
                    enabled: false,
                },
                toolbar: {
                    show: false
                },
                offsetX: -10,
            },
            grid: {
                show: true,
                borderColor: 'var(--grey-variation)',
            },
            stroke: {
                show: true,
                width: [...widthPropertiesBars, ...widthPropertiesLines],
                curve: [...curvePropertiesBars, ...curvePropertiesLines],
            },
            fill: {
                opacity: 1,
                type: 'solid',
            },
            colors: [...colorPropertiesBars, ...colorPropertiesLines],
            plotOptions: {
                bar: {
                    columnWidth: '30%',
                    horizontal: isBarHorizontal,
                }
            },
            xaxis: {
                type:'datetime',
                tickAmount: seriesConsumed[0]?.data.length-1,
                tickPlacement:'between',
                tooltip: {
                    enabled: false
                },
                axisBorder: {
                    show: true,
                    color: 'var(--axis-color)',
                },
                axisTicks: {
                    show: true,
                    height: 3,
                    color: 'var(--axis-color)',
                },
                labels: {
                    show: true,
                    style: {
                        colors: 'var(--axis-color)',
                        fontSize: props.widgetprop.props.extended.fontsize,
                        fontFamily: props.widgetprop.props.extended.fontfamily,
                        fontWeight: props.widgetprop.props.extended.fontweight,
                    },
                    formatter: function(value, timestamp, opts) {
                        console.log("value in xaxis",value)
                        console.log("timestamp in xaxis",timestamp)
                        console.log("opts in xaxis",opts)
                        console.log("Timestamp received:", value);
                        if (isNaN(value)) {
                            return '';
                        }
                    
                       // console.log("seriesConsumed[0]?.data.length",seriesConsumed[0]?.data.length)    
                        var index = opts?.i;
                        var thistimestamp = index!== undefined? opts.w.config.series[0].data[index]?.x:'';
                        console.log("thistimestamp",thistimestamp)
                        if(thistimestamp!== undefined && thistimestamp!==null && thistimestamp!==''){
                            var currentformatteddate = new Date(thistimestamp);
                            var currxvalue = '';
                            var options = { timeZone: "Asia/Kolkata" };
                        
                            console.log("Date being formatted:", currentformatteddate);
                        
                            switch (dateformatselected) {
                                case 'This Year':
                                case 'Last Year':
                                    currxvalue = currentformatteddate.toLocaleDateString('en-us', { ...options, month: "short" });
                                    //console.log("received currentformatteddate",currentformatteddate,"derived currxvalue",currxvalue)
                                    break;
                                case 'This Month':
                                case 'Last Month':
                                case 'Last 30 days':
                                    currxvalue = currentformatteddate.toLocaleDateString('en-us', { ...options, day: "numeric" });
                                    break;
                                case 'This Week':
                                case 'Last Week':
                                case 'Last 7 days':
                                    currxvalue = currentformatteddate.toLocaleDateString('en-us', { ...options, weekday: "short" });
                                    break;
                                case 'Today':
                                case 'Yesterday':
                                case 'Last 24 hours':
                                    var hrs=  currentformatteddate.getHours();
                                    var hrsstring = hrs.toString();
                                    if(hrsstring.length<2){
                                        hrsstring = "0"+hrsstring;
                                    }
                                    var mins = currentformatteddate.getMinutes();
                                    var minsstring = mins.toString();
                                    if(minsstring.length<2){
                                        minsstring = "0"+minsstring;
                                    }
                                    currxvalue = hrsstring+":"+minsstring;
                                    
                                    // currentformatteddate.toLocaleDateString('en-us', { hour: '2-digit',
                                    //     minute: '2-digit',
                                    //     hour12: false
                                    //    });
                                    //console.log("LINECHART IN THIS currentformatteddate---",currxvalue)
                                    break;
                                case 'Custom':
                                    if (seriesConsumed[0]?.data.length > 30) {
                                        currxvalue = (currentformatteddate.getDate() === 1) 
                                            ? currentformatteddate.toLocaleDateString('en-us', { ...options, day: "numeric", month: "short" }) 
                                            : '';
                                    } else {
                                        currxvalue = currentformatteddate.toLocaleDateString('en-us', { ...options, day: "numeric" });
                                    }
                                    break;
                                default:
                                    currxvalue = '';
                                    break;
                            }
                        
                            console.log("Formatted x-axis label:", currxvalue);
                            return currxvalue || '';
                        }
                            
                    }  
                },
                /*categories: categories,*/
            },
            yaxis: yaxisProperties,
            tooltip: {
                enabled: true,
                enabledOnSeries: undefined,
                custom: function({ series, seriesIndex, dataPointIndex, w }) {
                    const value = series[seriesIndex][dataPointIndex];
                    const timestamp = w.globals.seriesX[seriesIndex][dataPointIndex];
                
                    var currentFormattedDate = new Date(timestamp);
                    
                    var tooltipString = `<div style="display:flex; flex-direction:column; padding:5px;">`;
                    const options = { 
                        year: 'numeric', 
                        month: '2-digit', 
                        day: '2-digit', 
                        hour: '2-digit', 
                        minute: '2-digit', 
                        hour12: false 
                      }; 
                    var formattedDate = currentFormattedDate.toLocaleDateString('en-US', options).replace(/(\d{1,2})\/(\d{1,2})\/(\d{4})/g, '$3-$1-$2');;
                    // Begin building the tooltip string
    
                    tooltipString += `<div style="font-weight:600; color:#FFFFFF;">${formattedDate}</div>`;
                    for (var i = 0; i < series.length; i++) {
                        const seriesValue = series[i][dataPointIndex];
                        tooltipString += `
                        <div style="display:flex; align-items:center; margin-bottom:4px;">
                            <div style="height:8px; width:8px; background-color:${w.config.colors[i]}; border-radius:50%; margin-right:8px;"></div>
                            <div style="font-weight:600; color:#FFFFFF;">${seriesConsumed[i].name}</div>
                            <div style="margin-left:12px; color:#FFFFFF;">${(seriesValue == null)?("No Value"):seriesValue.toFixed(2)}</div>
                        </div>
                        `;
                    }
                    tooltipString += `</div>`;
                    return tooltipString;
                },
                hideEmptySeries: true,
                fillSeriesColor: false,
                theme: false,
                borderRadius:0,
                style: {
                  fontSize: "12px",
                  fontWeight: 800,
                  fontFamily: 'Roboto',
                },
              },
            legend: {
                show: true,
                fontSize: props.widgetprop.props.extended.legend.fontsize,
                fontFamily: props.widgetprop.props.extended.legend.fontfamily,
                fontWeight: props.widgetprop.props.extended.legend.fontweight,
                labels: {
                    colors: Array(colorPropertiesBars.length + colorPropertiesLines.length).fill('var(--legend-text-color)')
                },
                customLegendItems: [...legendNamePropertiesBars, ...legendNamePropertiesLines],
                markers: {
                    radius: props.widgetprop.props.extended.legend.marker.radius,
                    height: props.widgetprop.props.extended.legend.marker.height,
                    width: props.widgetprop.props.extended.legend.marker.width,
                    fillColors: [...colorPropertiesBars, ...colorPropertiesLines]
                }
            },
        };

        console.log("in useEffect mixed charts component seriesConsumed", seriesConsumed);
        console.log("in useEffect mixed charts component optionsConsumption", optionsConsumption);
        //console.log("categories for xaxis", categories);

        setSeriesChart(seriesConsumed);
        setOptions(optionsConsumption);
    }, [props.widgetprop, tagcollectionvalue,sdate_edate_selected]);

    return (
        <>          
            <Chart options={options} series={seriesChart} type="line" height="65%" width="100%" />
        </>
    );
}


